import { Card, Col, Row, Typography, theme as antdTheme } from 'antd';
import {
  CalendarOutlined,
  AppstoreOutlined,
  EnvironmentOutlined,
  TableOutlined,
  TagsOutlined,
  ControlOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router';
import { PageHeader } from '@/shared/components/page-header';

interface Tile {
  to: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

const tiles: Tile[] = [
  {
    to: '/setup/academic-years',
    title: 'Academic years',
    description: 'Define each session, its date range, and which one is current.',
    icon: <CalendarOutlined />,
  },
  {
    to: '/setup/classes',
    title: 'Classes',
    description: 'Grades / classes, their sort order, and how marks are displayed.',
    icon: <AppstoreOutlined />,
  },
  {
    to: '/setup/class-sections',
    title: 'Class × Section per year',
    description: 'Assign sections to classes for the selected academic year.',
    icon: <TableOutlined />,
  },
  {
    to: '/setup/cities',
    title: 'Cities & areas',
    description: 'Address book entries used across student and staff records.',
    icon: <EnvironmentOutlined />,
  },
  {
    to: '/setup/lookups',
    title: 'Lookup catalogs',
    description: 'Genders, religions, subjects, exam types, departments, and more.',
    icon: <TagsOutlined />,
  },
  {
    to: '/setup/system-settings',
    title: 'System settings',
    description: 'Global thresholds and rules — defaulter window, approval limits, session timeout.',
    icon: <ControlOutlined />,
  },
];

export function SetupHubPage() {
  const { token } = antdTheme.useToken();
  return (
    <div style={{ display: 'grid', gap: 22 }}>
      <PageHeader
        eyebrow="Module"
        title="Setup"
        description="Master and lookup data that everything else hangs off. Changes are audited."
      />

      <Row gutter={[16, 16]}>
        {tiles.map((t) => (
          <Col key={t.to} xs={24} sm={12} xl={8}>
            <Link to={t.to} style={{ textDecoration: 'none' }}>
              <Card
                hoverable
                className="lift-card"
                style={{ height: '100%', borderColor: token.colorBorderSecondary }}
                styles={{ body: { padding: 20 } }}
              >
                <div style={{ display: 'flex', gap: 14 }}>
                  <span
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      display: 'grid',
                      placeItems: 'center',
                      background: token.colorFillTertiary,
                      color: token.colorPrimary,
                      fontSize: 18,
                      flexShrink: 0,
                    }}
                  >
                    {t.icon}
                  </span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                      <Typography.Text strong style={{ fontSize: 15 }}>
                        {t.title}
                      </Typography.Text>
                      <RightOutlined style={{ fontSize: 12, color: token.colorTextTertiary }} />
                    </div>
                    <Typography.Text type="secondary" style={{ fontSize: 13, display: 'block', marginTop: 4 }}>
                      {t.description}
                    </Typography.Text>
                  </div>
                </div>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
